import { Checkbox } from 'components/tailwind-ui/Checkbox';
import { FilterDropdown } from 'components/tailwind-ui/FilterDropdown';
import _ from 'lodash';
import * as React from 'react';
import { WatchedShipment } from 'services/clients/watchList';
import { useFilterSearchParams } from '../../hooks';

interface StatusEntry {
  status: WatchedShipment['trackingStatus'];
  label: string;
}

const StatusEntries: StatusEntry[] = [
  { status: 'ARCHIVED', label: 'Inactive' },
  { status: 'LOCATING', label: 'Locating' },
  { status: 'TRACKING', label: 'Tracking' },
  {
    status: 'UNABLE_TO_LOCATE',
    label: 'Unable to locate',
  },
  { status: 'DELETED', label: 'Deleted' },
];

type FilterState = WatchedShipment['trackingStatus'];

export const TrackStatus: React.FC = () => {
  const { searchParams, setSearchParams } = useFilterSearchParams(true);

  const filterStates = React.useMemo(() => {
    const filters: FilterState[] = [];
    searchParams.trackingStatus.forEach((s: string) => {
      filters.push(s as WatchedShipment['trackingStatus']);
    });
    return filters;
  }, [searchParams]);

  const handleClearFilter = () => {
    setSearchParams({ trackingStatus: [] });
  };

  const handleOnChangeCheckbox = (trackingStatus: FilterState, checked: boolean) => {
    if (checked) {
      setSearchParams({
        trackingStatus: [...new Set([...filterStates, trackingStatus as string])],
      });
    } else {
      setSearchParams({ trackingStatus: _.pull(filterStates, trackingStatus) });
    }
  };

  const count = filterStates.length;

  return (
    <FilterDropdown label="Tracking status" count={count} clear={handleClearFilter}>
      {StatusEntries.map((entry) => (
        <Checkbox
          id={`status-${entry.status}`}
          key={entry.status}
          className="px-3 py-2 hover:bg-blue-200"
          checked={filterStates.includes(entry.status)}
          onCheck={(checked) => handleOnChangeCheckbox(entry.status, checked)}
          label={entry.label}
        />
      ))}
    </FilterDropdown>
  );
};
